import nanoScroller from '@global/vendors/jquery.nanoscroller.min';
import Vue from 'vue';
import cartNotification from '@global/components/cart/cartNotification';
import AlertDialog from '@global/helpers/alertDialog';
import messageBox from '@global/helpers/messageBox';
import store from '@global/components/store/index';
import { createNamespacedHelpers } from 'vuex';
import NewImage from '@global/components/global/image';
import $ from 'jquery';
import { fireSearchListEvent } from '@global/gtm/shopList/shopListView';
import fireSearchEvent from '@global/gtm/search';
import GlobalCtrl from './globalCtrl';
import axios from 'axios';
import Marquee from '../../../template/home/Marquee.pug';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('miniCartModule');

global.$ = global.jQuery = require('jquery'); // fix can't use JQ in inline script

require('sticky-kit/dist/sticky-kit');

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

if ($('#app-mini-cart').length > 0) {
  window.appNotificationCart = new Vue({
    el: '#app-mini-cart',
    store,
    components: { NewImage },
    data() {
      return {
        cartContentHeight: '',
        hasProduct: 0,
      };
    },
    computed: {
      ...mapState([
        'totalCount',
        'generalCount',
        'refrigerationCount',
        'freezingCount',
        'temperaturesData',
        'dataIsLoad',
        'count',
        'hotSearch',
        'hotLoad',
      ]),
      ...mapGetters(['isOnlyOneTemp']),
    },
    watch: {
      totalCount(val) {
        this.onSetCartHeight();
      },
      hotLoad(value) {
        if (value && window.location.pathname.includes('search')) {
          fireSearchListEvent(this.hotSearch);
        }
      },
    },
    created() {
      this.getCartInfo();
      this.getHotSearch();
    },
    methods: {
      ...mapActions(['getCartInfo', 'getHotSearch']),
      onSetCartHeight() {
        if (this.totalCount !== 0) {
          if (this.isOnlyOneTemp && this.generalCount !== 0) {
            if (this.temperaturesData[0].Markets.length > 4) {
              this.cartContentHeight = (4 * 90).toString() + 'px';
              document.getElementById('miniCart-all').style.overflowY = 'scroll';
            } else {
              this.cartContentHeight =
                (this.temperaturesData[0].Markets.length * 90).toString() + 'px';
            }
            document.getElementById('miniCart-all').style.height = this.cartContentHeight;
          } else {
            if (this.generalCount !== 0) {
              this.hasProduct++;
            }

            if (this.refrigerationCount !== 0) {
              this.hasProduct++;
            }

            if (this.freezingCount !== 0) {
              this.hasProduct++;
            }
            this.cartContentHeight = (this.hasProduct * 57.5).toString() + 'px';
            document.getElementById('miniCart-all').style.height = this.cartContentHeight;
            this.hasProduct = 0;
          }
        }
      },
      goSearch(item) {
        window.location.href = `/search?Keyword=${item}`;
        fireSearchEvent({
          isHotSearch: true,
          keyword: item,
        });
      },
      spread() {
        $('.hot-input-block').addClass('open');
        $('.hot-cancel').css('display', 'block');
      },
      cancel() {
        $('.hot-input-block').removeClass('open');
        $('.hot-cancel').css('display', 'none');
        $('.hot-input').val('');
      },
    },
  });
}

function gotosearch(inputVal) {
  if (inputVal === '') {
    window.nowBrand.alert('請輸入文字', '貼心提醒');
    event.preventDefault();
  } else {
    window.location.href = `/search?Keyword=${inputVal}`;
    fireSearchEvent({
      isHotSearch: false,
      keyword: inputVal,
    });
  }
}

$('#searchForm').on('submit', function (event) {
  event.preventDefault();
  gotosearch($(this).find('input').val());
});

$('.submit').click(function (event) {
  event.preventDefault();
  gotosearch($(this).parents('form').find('input').val());
});

GlobalCtrl();

const marquee = new Vue({
  el: '#header-marquee',
  data() {
    return {
      marquee: {},
      isShowMarquee: false,
    };
  },
  async created() {
    this.isShowMarquee = false;
    const versionNumber = this.generateVersionNumber();
    // const loadJson = './api/json/marquee.json';

    let loadJson = '';

    if (window.PictureContainer.indexOf('-t') !== -1) {
      loadJson = `https://static.tpx.tw/sff-t/mercci22/json/marquee.json?v=${versionNumber}`;
    } else {
      loadJson = `https://static.tpx.tw/sff/mercci22/json/marquee.json?v=${versionNumber}`;
    }

    let marqueeArray = [];
    const now = Date.now();

    try {
      const res = await axios.get(loadJson);
      marqueeArray = res.data.Response;

      marqueeArray.forEach((element) => {
        const startTime = new Date(element.startTime).getTime();
        const endTime = new Date(element.endTime).getTime();
        if (now >= startTime && now <= endTime) {
          this.marquee = element;
          this.isShowMarquee = true;
        }
      });

      Object.entries(this.marquee.themeColors).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value);
      });
    } catch (err) {
      this.isShowMarquee = false;
    }
  },
  methods: {
    generateVersionNumber() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const date = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');

      return `${year}${month}${date}${hour}`;
    },
  },
  template: Marquee,
});

// 電子報
window.RecordNewsletter = function () {
  $.ajax({
    type: 'POST',
    url: '/api/v1/Subscribe/Apply',
    dataType: 'json',
    data: { Email: $('#input-newsletter').val() },
    xhrFields: {
      withCredentials: false,
    },
    error: function () {
      console.log('error');
    },
    success: function (res) {
      AlertDialog.alert(res.Message);
      // aqTrace.subscribedMail({mail: $("#input-newsletter").val()})
    },
  });
};

// 全域方法前後端使用
window.AlertDialog = AlertDialog;
window.messageBox = messageBox;
window.Vue = Vue;
